module.exports = __webpack_public_path__ + "img/avatar.d304d3ed.png";